import { routeList } from '@/router/helpers/routes'
import { ACCOUNT_MAIN_CURRENCY, ACCOUNT_TYPES, ACCOUNT_FAMILIES } from '@/assets/constants/accounts'

/* URL for curresponding Account Types */
export const getAccountRoute = (accountType) => {
	const accountsRoutes = {
		DO: routeList.CONSULT_BALANCES_AND_MOVEMENTS_PATH,
		DWALLET: routeList.CONSULT_BALANCES_AND_MOVEMENTS_PATH,
		CRR: routeList.CREDIT_CONSULT_PATH,
		CRF: routeList.CREDIT_CONSULT_PATH,
		CCO: routeList.CREDIT_CONSULT_PATH,
		DP: routeList.SAVINGS_CREATE_DP_PATH
	}

	return accountsRoutes[accountType]
}

/* Route Name for curresponding Account Types */
export const getAccountRouteName = (accountType) => {
	const accountsRoutesNames = {
		DO: routeList.ACCOUNTS_BALANCES_AND_MOVEMENTS_NAME,
		DWALLET: routeList.ACCOUNTS_BALANCES_AND_MOVEMENTS_NAME,
		CRR: routeList.CREDITS_MY_CREDITS_NAME,
		CRF: routeList.CREDITS_MY_CREDITS_NAME,
		CCO: routeList.CREDITS_MY_CREDITS_NAME,
		DP: routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_NAME
	}

	return accountsRoutesNames[accountType]
}

export const accountsTypesForOperations = {
	/* Still missing a lot of routeNames here */
	HOME: [ACCOUNT_TYPES.DO, ACCOUNT_TYPES.DWALLET],
	HOME_MOBILE: [ACCOUNT_TYPES.DO, ACCOUNT_TYPES.DWALLET],
	ACCOUNTS_DETAILS: [ACCOUNT_TYPES.DO, ACCOUNT_TYPES.DWALLET],
	ACCOUNTS_BALANCES_AND_MOVEMENTS: [ACCOUNT_TYPES.DO, ACCOUNT_TYPES.DWALLET],
	TRANSFERS_PERIODIC: [ACCOUNT_TYPES.DO],
	APPROVALS_SIGNED_BY_ME: [ACCOUNT_TYPES.DO, ACCOUNT_TYPES.DWALLET],
	TRANSFERS_NACIONAL: [ACCOUNT_TYPES.DO, ACCOUNT_TYPES.DWALLET],
	TRANSFERS_INTERNATIONAL: [ACCOUNT_TYPES.DO],
	TRANSFERS_INTERNATIONAL_CORPORATE: [ACCOUNT_TYPES.DO],
	TRANSFERS_INSTANT_BAI: [ACCOUNT_TYPES.DO],
	TRANSFERS_KWIK: [ACCOUNT_TYPES.DO, ACCOUNT_TYPES.DWALLET],
    TRANSFERS_KWIK_TRANSFER: [ACCOUNT_TYPES.DO, ACCOUNT_TYPES.DWALLET],
    TRANSFERS_KWIK_MANAGE_ACCOUNTS: [ACCOUNT_TYPES.DO],
	PAYMENTS_SERVICES_FLOW_DSTV: [ACCOUNT_TYPES.DO, ACCOUNT_TYPES.DWALLET],
	PAYMENTS_REQUESTS_BAI_PAGA_PAY: [ACCOUNT_TYPES.DO, ACCOUNT_TYPES.DWALLET],
	PAYMENTS_SERVICES_FLOW_EMIS_REFERENCE: [ACCOUNT_TYPES.DO, ACCOUNT_TYPES.DWALLET],
	PAYMENTS_SERVICES_FLOW_EMIS_SPECIAL: [ACCOUNT_TYPES.DO, ACCOUNT_TYPES.DWALLET],
	PAYMENTS_SERVICES_FLOW_EMIS_VOUCHER: [ACCOUNT_TYPES.DO, ACCOUNT_TYPES.DWALLET],
	PAYMENTS_SERVICES_FLOW_UNITEL: [ACCOUNT_TYPES.DO, ACCOUNT_TYPES.DWALLET],
    PAYMENTS_MINFIN: [ACCOUNT_TYPES.DO],
	PAYMENTS_BAI_PAGA: [ACCOUNT_TYPES.DO],
    PAYMENTS_BATCHFILE_NEW_PAYMENT: [ACCOUNT_TYPES.DO],
	CARDS_TRANSFERS_FLEX: [ACCOUNT_TYPES.DO],
	CARDS_CHARGE_FLEX: [ACCOUNT_TYPES.DO],
    CARDS_CHARGE_DIRECT_KAMBA: [ACCOUNT_TYPES.DO],
    CARDS_CHARGE_VIRTUAL: [ACCOUNT_TYPES.DO],
    CARDS_REQUEST_CARD_GENERIC: [ACCOUNT_TYPES.DO],
	CARDS_BATCHFILE_NEW_CHARGE_FLEX: [ACCOUNT_TYPES.DO],
	CARDS_BATCHFILE_NEW_CHARGE_KAMBA: [ACCOUNT_TYPES.DO],
	CARDS_BATCHFILE_NEW_CHARGE_MULTICAIXA: [ACCOUNT_TYPES.DO],
	BANKASSURANCE_SUBSCRIBE_TRAVEL: [ACCOUNT_TYPES.DO],
	BANKASSURANCE_SUBSCRIBE_AUTO: [ACCOUNT_TYPES.DO],
	BANKASSURANCE_SUBSCRIBE_HEALTH: [ACCOUNT_TYPES.DO],
	CARDS_ANTICIPATE_PAYMENT: [ACCOUNT_TYPES.DO],
	SAVINGS_MY_SAVINGS_PORTFOLIO_CHARGE: [ACCOUNT_TYPES.DO],
	SAVINGS_PRODUCTS_CONSTITUTE: [ACCOUNT_TYPES.DO],
	REQUEST_MONEY_NAHORA: [ACCOUNT_TYPES.DO, ACCOUNT_TYPES.DWALLET],
	CREDITS_MY_CREDITS: [ACCOUNT_TYPES.CRR, ACCOUNT_TYPES.CRF],
	CREDITS_MY_CREDITS_AMORTIZATION: [ACCOUNT_TYPES.DO],
    CREDITS_CREDIT_SOLUTIONS: [ACCOUNT_TYPES.DO],
	RECEIVE_PAYMENTS_TPA_REQUEST_BAI: [ACCOUNT_TYPES.DO, ACCOUNT_TYPES.DWALLET],
	COMPANY_PAYMENTS_REQUEST_TPA_BAI: [ACCOUNT_TYPES.DO],
    CREDIT_CREDIT_SOLUTIONS_SUBSCRIBE_PRODUCT: [ACCOUNT_TYPES.DO]
}

export const accountsFamiliesForOperations = {
	CREDIT_CONSULT: [ACCOUNT_FAMILIES.liabilities]
}

export const accountsCurrenciesOperation = {
	/* Still missing a lot of routeNames here */
	CARDS_ANTICIPATE_PAYMENT: [ACCOUNT_MAIN_CURRENCY],
	PAYMENTS_SERVICES_FLOW_EMIS_REFERENCE: [ACCOUNT_MAIN_CURRENCY],
	PAYMENTS_SERVICES_FLOW_EMIS_SPECIAL: [ACCOUNT_MAIN_CURRENCY],
	PAYMENTS_SERVICES_FLOW_EMIS_VOUCHER: [ACCOUNT_MAIN_CURRENCY],
	PAYMENTS_SERVICES_FLOW_UNITEL: [ACCOUNT_MAIN_CURRENCY],
    PAYMENTS_MINFIN: [ACCOUNT_MAIN_CURRENCY],
	CARDS_CHARGE_FLEX: [ACCOUNT_MAIN_CURRENCY],
	CARDS_CHARGE_VIRTUAL: [ACCOUNT_MAIN_CURRENCY],
	CARDS_REQUEST_CARD_GENERIC: [ACCOUNT_MAIN_CURRENCY],
	CARDS_BATCHFILE_NEW_CHARGE_FLEX: [ACCOUNT_MAIN_CURRENCY],
	CARDS_BATCHFILE_NEW_CHARGE_KAMBA: [ACCOUNT_MAIN_CURRENCY],
	CARDS_BATCHFILE_NEW_CHARGE_MULTICAIXA: [ACCOUNT_MAIN_CURRENCY],
	BANKASSURANCE_SUBSCRIBE_TRAVEL: [ACCOUNT_MAIN_CURRENCY],
	BANKASSURANCE_SUBSCRIBE_AUTO: [ACCOUNT_MAIN_CURRENCY],
	BANKASSURANCE_SUBSCRIBE_HEALTH: [ACCOUNT_MAIN_CURRENCY],
	CREDITS_MY_CREDITS_AMORTIZATION: [ACCOUNT_MAIN_CURRENCY],
	RECEIVE_PAYMENTS_TPA_REQUEST_BAI: [ACCOUNT_MAIN_CURRENCY],
	COMPANY_PAYMENTS_REQUEST_TPA_BAI: [ACCOUNT_MAIN_CURRENCY],
    PAYMENTS_BATCHFILE_NEW_PAYMENT: [ACCOUNT_MAIN_CURRENCY],
    TRANSFERS_INSTANT_BAI: [ACCOUNT_MAIN_CURRENCY],
    TRANSFERS_KWIK_MANAGE_ACCOUNTS: [ACCOUNT_MAIN_CURRENCY]
}
